export function formatDate(d) {
  if (!d) return '—';
  const utc = String(d).includes('Z') || String(d).includes('+') ? d : d + 'Z';
  return new Date(utc).toLocaleString('en-IN', { month: 'short', day: 'numeric', year: 'numeric', hour: '2-digit', minute: '2-digit' });
}

export function timeAgo(d) {
  if (!d) return '—';
  const utc = String(d).includes('Z') || String(d).includes('+') ? d : d + 'Z';
  const diff = Date.now() - new Date(utc);
  const mins = Math.floor(diff / 60000);
  if (mins < 1) return 'just now';
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs}h ago`;
  return `${Math.floor(hrs / 24)}d ago`;
}

export function slaColor(ticket) {
  if (!ticket.due_at) return '';
  const breached = new Date(ticket.due_at) < new Date() && !['resolved','closed'].includes(ticket.status);
  return breached ? 'sla-breached' : '';
}

export const CATEGORIES = ['general', 'billing', 'technical', 'account', 'feature-request', 'bug'];
export const PRIORITIES = ['low', 'medium', 'high', 'critical'];
export const ISSUE_TYPES = [
  'Link / Internet down',
  'Device faulty (RMA)',
  'Slow / intermittent',
  'Configuration / policy',
  'Login / access',
  'Installation / setup',
  'Report request',
  'Power / hardware',
  'Other',
];
export const STATUSES = ['open', 'in_progress', 'resolved', 'closed'];
